// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-EditRoute-styles---container---xsbOo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditRoute/styles.css
// module id = 830
// module chunks = 0